import React, {useCallback, useEffect, useMemo, useState} from 'react'
import styled from 'styled-components'
import Button from '@mui/material/Button'
import {Add, Refresh} from '@mui/icons-material'
import {useNavigate} from 'react-router-dom'
import { useLazyQuery} from '@apollo/client'
import {ToggleButton, ToggleButtonGroup} from '@mui/material'
import Grid from '@mui/material/GridLegacy'
import {ROUTES} from '@/utils/routes'
import DatasetTab from '@/components/pages/JobsPage/DatasetTab'
import DatabaseTab from './DatabaseTab'
import {VARIANT_DATABASE_JOBS_QUERY, VARIANT_DATASET_JOBS_QUERY} from '@/graphql/query/queries'

const StyledJobPageContainer = styled.div`
    margin-top: 2rem;
    margin-bottom: 2rem;
    width: 100%;
`

const StyledJobButtonContainer = styled.div`
    display: flex;
    justify-content: end;
    width: 100%;
    margin-bottom: 1em;
    gap: 1em
`

const StyledRefresh = styled(Refresh)`
    margin-right: 0.5em;
`

const StyledAdd = styled(Add)`
    margin-right: 0.5em;
`

const JobsPage = () => {
    const [toggleValue, setToggleValue] = useState<'dataset' | 'database' | undefined>(undefined)

    const navigate = useNavigate()

    const [getDatasetJobList, {
        data: datasetJobsData,
        loading: datasetsLoading,
        error: datasetsError,
        refetch: refetchDatasetJobs
    }] = useLazyQuery(VARIANT_DATASET_JOBS_QUERY, {notifyOnNetworkStatusChange: true, fetchPolicy: 'network-only'})
    const [getDatabaseJobList, {
        data: databaseJobsData,
        loading: databasesLoading,
        error: databasesError,
        refetch: refetchDatabaseJobs
    }] = useLazyQuery(VARIANT_DATABASE_JOBS_QUERY, {notifyOnNetworkStatusChange: true, fetchPolicy: 'network-only'})

    const newJobButtonName = useMemo(() => {
        return toggleValue === 'dataset' ? 'New dataset job' : 'new database job'
    }, [toggleValue])

    const handleToggle = useCallback((_evt: any, value: any) => {
        setToggleValue(value)
    }, [])

    const handleRefresh = useCallback((toggleVal?: string) => {
        if(toggleVal === 'dataset') {
            refetchDatasetJobs()
        } else if (toggleVal === 'database') {
            refetchDatabaseJobs()
        }
    }, [])

    const handleNewJobRedirect = useCallback((toggleVal?: string) => {
        if(toggleVal === 'dataset') {
            navigate(ROUTES.NEW_DATASET)
        } else if(toggleVal === 'database') {
            navigate(ROUTES.NEW_DATABASE)
        }
    }, [])

    // TODO popremyslet o reduceru... to usnadni dost prace
    useEffect(() => {
        const urlToggleVal = new URLSearchParams(window.location.search).get('toggle')
        if(urlToggleVal && (urlToggleVal === 'database' || urlToggleVal === 'dataset')) {
            setToggleValue(urlToggleVal)
        } else {
            setToggleValue('dataset')
        }
    }, [])

    useEffect(() => {
        if(toggleValue === 'dataset') {
            getDatasetJobList()
        } else if(toggleValue === 'database') {
            getDatabaseJobList()
        }
    }, [toggleValue])

    return (
        <StyledJobPageContainer>
            <Grid container pb={2}>
                <Grid item xs={6}>
                    <ToggleButtonGroup value={toggleValue} exclusive onChange={handleToggle}>
                        <ToggleButton color="primary" value="dataset">DATASET</ToggleButton>
                        <ToggleButton color="primary" value="database">DATABASE</ToggleButton>
                    </ToggleButtonGroup>
                </Grid>
                {/*TODO celej tenhle grid vytahni do samostatne komponenty a posli tam new page funkci a refresh funkci??*/}
                <Grid item xs={6}>
                    <StyledJobButtonContainer>
                        <Button variant="contained" onClick={() => handleRefresh(toggleValue)}><StyledRefresh/>Refresh
                            jobs</Button>
                        <Button variant="contained"
                            onClick={() => handleNewJobRedirect(toggleValue)}><StyledAdd/>{newJobButtonName}</Button>
                    </StyledJobButtonContainer>
                </Grid>
            </Grid>
            {toggleValue === 'dataset' ?
                <DatasetTab
                    datasetJobs={datasetJobsData?.variantDatasetJobList}
                    datasetsLoading={datasetsLoading}
                    datasetsError={!!datasetsError}/>
                :
                <DatabaseTab
                    databaseJobs={databaseJobsData?.variantDatabaseJobList}
                    databasesLoading={databasesLoading}
                    databasesError={!!databasesError}/>
            }
        </StyledJobPageContainer>
    )
}

export default JobsPage